

<div class="top-background" style="background-image:url(images/backgrounds/tools.jpg);">
    <h1 class="page-title">LCML Developed Tools</h1>
</div>

<div class="content">
    <section id="tool-links">
        Add a link here
    </section>
</div>




<style lang="sass">

@import "../consts.sass"
@include page-header()

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw
        
</style>